// libs
import React, { createContext, useContext } from 'react';

// defs
interface IWidgetContext {
  setWidgetEl: (widgetEl: React.RefObject<HTMLDivElement>) => void;
  scrollToWidget: VoidFunction;
  setOnScrollCallback: (cb: VoidFunction) => void;
}

const EMPTY_FUNC = () => {
  /** DO NOTHING */
};

const initialValue: IWidgetContext = {
  setWidgetEl: EMPTY_FUNC,
  scrollToWidget: EMPTY_FUNC,
  setOnScrollCallback: EMPTY_FUNC,
};

const WidgetContext = createContext(initialValue);

export const useWidgetContext = () => useContext(WidgetContext);

export default WidgetContext;
